type LocalStorageKeys = {
    viewedPosts: number[]
    tempImage: string // TODO можно убрать когда тест 1488 закончится, ключ чтобы не грузить картинки в бд
}

class LocalStorageService {
    getItem<K extends keyof LocalStorageKeys>(key: K): LocalStorageKeys[K] | null {
        try {
            const item = localStorage.getItem(key)
            if (!item) return null
            return JSON.parse(item) as LocalStorageKeys[K]
        } catch (error) {
            console.error(`Error parsing localStorage key "${key}":`, error)
            return null
        }
    }

    set<K extends keyof LocalStorageKeys>(key: K, value: LocalStorageKeys[K]): void {
        try {
            const item = JSON.stringify(value)
            localStorage.setItem(key, item)
        } catch (error) {
            console.error(`Error setting localStorage key "${key}":`, error)
        }
    }

    remove<K extends keyof LocalStorageKeys>(key: K): void {
        try {
            localStorage.removeItem(key)
        } catch (error) {
            console.error(`Error removing localStorage key "${key}":`, error)
        }
    }

    add<K extends keyof LocalStorageKeys>(key: K, value: LocalStorageKeys[K] extends Array<any> ? LocalStorageKeys[K][number] : never): void {
        const current = this.getItem(key)

        if (Array.isArray(current)) {
            if (!current.includes(value)) {
                current.push(value)
                this.set(key, current as LocalStorageKeys[K])
            }
        } else {
            console.error(`Key "${key}" does not contain an array.`)
        }
    }

    contains<K extends keyof LocalStorageKeys>(key: K, value: LocalStorageKeys[K] extends Array<any> ? LocalStorageKeys[K][number] : never): boolean {
        const current = this.getItem(key)
        if (Array.isArray(current)) {
            return current.includes(value)
        } else {
            // console.error(`Key "${key}" does not contain an array.`)
            return false
        }
    }
}

export const localStorageService = new LocalStorageService()
